<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="DEDICATION _idGenParaOverride-1">Dedicated to my wife Nancy,<br/>	our three adult children, Mark, Amy, and Brian,<br/>		and Rev. Mark A. Derby<br/>			for their ongoing participation in the <em class="italic">missio Dei</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gorman_Becoming_the_Gospel_text_CC2.vue?6702a1c6